import React from 'react';
import PropTypes from 'prop-types';
import {useTranslate} from '@computerrock/formation-i18n';
import {alfOutgoingMessageCategoryTypes, alfMessageChannelTypes} from '@ace-de/eua-entity-types';
import {useStyles} from '@ace-de/ui-components';
import {SelectField, Option} from '@ace-de/ui-components/form';
import categoryToTextTemplatesMap from '../categoryToTextTemplatesMap';
import styles from '../modals/CommunicationModals.module.scss';

const CategoryTemplateSection = props => {
    const {cx} = useStyles(props, styles);
    const {selectedCategory, selectedTemplate, selectedChannel, isDisabled} = props;
    const {onCategoryChange, onTemplateChange} = props;
    const {createTranslateShorthand} = useTranslate();
    const translateModal = createTranslateShorthand('send_message_modal');

    return (
        <>
            <SelectField
                className={cx('global!ace-u-margin--bottom-32')}
                name="type"
                label={translateModal('select_field_label.type')}
                value={selectedCategory || ''}
                onChange={onCategoryChange}
                isDisabled={isDisabled}
            >
                {Object.values(alfOutgoingMessageCategoryTypes).filter(category => (
                    selectedChannel !== alfMessageChannelTypes.ELLA
                    || (selectedChannel === alfMessageChannelTypes.ELLA
                    && category === alfOutgoingMessageCategoryTypes.ELLA)
                )).map((category, idx) => (
                    <Option
                        value={category}
                        name={`category${category}`}
                        key={`${category}-${idx}`}
                    >
                        {translateModal(`communication_type_option.${category.toLowerCase()}`)}
                    </Option>
                ))}
            </SelectField>
            {selectedCategory && (
                <SelectField
                    className={cx('global!ace-u-margin--bottom-32')}
                    name="template"
                    label={translateModal('select_field_label.template')}
                    value={selectedTemplate}
                    onChange={onTemplateChange}
                    isDisabled={isDisabled}
                >
                    {categoryToTextTemplatesMap[selectedCategory].map(textTemplate => (
                        <Option
                            name={textTemplate}
                            key={`textTemplate${textTemplate}`}
                            value={textTemplate}
                        >
                            {translateModal(`text_template_option.${textTemplate.toLowerCase()}`)}
                        </Option>
                    ))}
                </SelectField>
            )}
        </>
    );
};

CategoryTemplateSection.propTypes = {
    selectedCategory: PropTypes.string,
    selectedTemplate: PropTypes.string,
    selectedChannel: PropTypes.string,
    isDisabled: PropTypes.bool,
    onCategoryChange: PropTypes.func.isRequired,
    onTemplateChange: PropTypes.func.isRequired,
};

CategoryTemplateSection.defaultProps = {
    selectedCategory: undefined,
    selectedTemplate: undefined,
    selectedChannel: '',
    isDisabled: false,
};

export default CategoryTemplateSection;
